import React from 'react';
import InnerNoteList from '../../note/InnerNoteList';

class ContactTab extends React.Component {
  render() {
    const tab = this.props.activeTab;
    return (
    <div className={`tab-pane fade ${tab === 'note' ? 'show active in' : ''}`}>
        <div className="row">
            <div className="col-md-12">
              <InnerNoteList id={this.props.id} type={this.props.type} {...this.props} 
                onLoad={this.props.onLoad} reload={this.props.reload} show={this.props.show} 
                edit={this.props.edit} />
            </div>
        </div>
    </div>
    );
  }
}
export default ContactTab;